import { decimalUpTo } from 'Helpers/currencyFormat';
import { formatFigure, parseFormattedMoney, ZERO_DASH } from 'Helpers/formatService';

export { ZERO_DASH };

/** A money figure in the project's number format, whole units; zero shows a dash. */
export const money = (value) => formatFigure(value);

/** A percentage to at most one decimal, in the project's number format. */
export const percent = (value) => {
    const n = Number(value);

    if (value === null || value === undefined || Number.isNaN(n)) {
        return '';
    }

    // A share that rounds to nothing still shows it is there.
    return n > 0 && n < 0.05 ? `<${decimalUpTo(0.1, 1)}%` : `${decimalUpTo(n, 1)}%`;
};

/** A percentage as an editable string (up to six decimals, no grouping noise). */
export const editablePercent = (value) => (value === null || value === undefined ? '' : decimalUpTo(Number(value), 6));

/** An editable whole-unit money string in the project's number format. */
export const editableMoney = (value) => (value === null || value === undefined ? '' : decimalUpTo(Math.round(Number(value) * 100) / 100, 2));

/**
 * A typed number in the project's number format; a lone "." or "," is also read as
 * the decimal separator so "12.5" and "12,5" both work. Blank is null, junk is NaN.
 */
export const parseNumber = (text) => {
    const trimmed = String(text ?? '').trim();

    if (trimmed === '') {
        return null;
    }

    const parsed = parseFormattedMoney(trimmed);

    if (!Number.isNaN(parsed)) {
        return parsed;
    }

    const plain = trimmed.replace(/\s/g, '');

    return /^\d+([.,]\d+)?$/.test(plain) ? Number(plain.replace(',', '.')) : NaN;
};
